import { graphql } from "gql";

const DELETE_ALL_JOBS_MUTATION = graphql(`
  mutation DeleteAllJobs {
    deleteAllJobs
  }
`);

export default DELETE_ALL_JOBS_MUTATION;
